import store from '@/store/index'
import axios from '@/lib/axios'

export function updateProfile(params) {
  return axios().put('/api/users/update_info', params)
}
